import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../../lib/api/client';
import type { ResetPasswordRequest } from '@lov/shared';

export function useResetPassword() {
  return useMutation({
    mutationFn: async (data: ResetPasswordRequest) => {
      const response = await apiClient.post('/auth/reset-password', data);
      return response.data;
    },
  });
}
